import { Link } from "gatsby"
import React from "react"

import ScrollAnimation from "react-animate-on-scroll"

import "animate.css/animate.min.css"

import arrow from "../../images/right-arrow.svg"
import { AnchorLink } from "gatsby-plugin-anchor-links"

const FCButton = ({ buttonText, url, anim, anchor }: any) => {
  return (
    <>
      {!anchor ? (
        <>
          {!anim ? (
            <ScrollAnimation animateIn="animate__bounceIn" duration={1.0}>
              <button className="fcbuttonwhite btn-mix-noborder">
                <div className="fctec-wrap flex ac jc">
                  <Link to={url}>{buttonText}</Link>
                  <img src={arrow} alt="" />
                </div>
              </button>
            </ScrollAnimation>
          ) : (
            <button className="fcbuttonwhite btn-mix-noborder">
              <div className="fctec-wrap flex ac jc">
                <Link to={url}>{buttonText}</Link>
                <img src={arrow} alt="" />
              </div>
            </button>
          )}
        </>
      ) : (
        <>
          {!anim ? (
            <ScrollAnimation animateIn="animate__bounceIn" duration={1.0}>
              <button className="fcbuttonwhite btn-mix-noborder">
                <div className="fctec-wrap flex ac jc">
                  <Link to={url}>{buttonText}</Link>
                  <img src={arrow} alt="" />
                </div>
              </button>
            </ScrollAnimation>
          ) : (
            <button className="fcbuttonwhite btn-mix-noborder">
              <div className="fctec-wrap flex ac jc">
                <AnchorLink to={url}>{buttonText}</AnchorLink>
                <img src={arrow} alt="" />
              </div>
            </button>
          )}
        </>
      )}
    </>
  )
}

export default FCButton
